import { Component, OnInit, Inject, Input, InjectionToken } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import { Paginate } from '../../search-document-sign/search-document-sign.component';
import { DataSource } from '@angular/cdk/collections';
import {BehaviorSubject, merge, Observable, Subscription} from 'rxjs';
import { DocumentService } from 'src/app/core/services/document.service';
import { debug } from 'util';
import {Message} from '../../../../../../../core/class/message';
import {CommonService} from '../../../../../../../core/services/common.service';
import {tap} from "rxjs/operators";
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import {ResponsiveService} from "../../../../../../../core/services/responsive.service";
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import {ToastrService} from 'ngx-toastr';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';

/**
 * The document model.
 */
export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
}

/**
 * document source.
 */
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-sign-document-list',
  templateUrl: './sign-document-list.component.html'
})

/**
 * Sign document list component.
 */
export class SignDocumentListComponent implements OnInit {
  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  

  dataSource: any;

  tmp: any;

  paginate: Paginate;
  isVContract:boolean=true;

  documents = new Document();

  noOfFiles: 0;
  notifyWarning: string;
  completeData: boolean = false;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'noOfFile',
    'allName',
    'createdUser',
    'receivedTime'
    // 'symbol',
  ];
  columnDefinitions = [
    {def: 'STT',showMobile:true},
    {def: 'contractName',showMobile:true},
    {def: 'noOfFile',showMobile:true},
    {def: 'allName', showMobile:false},
    {def: 'createdUser', showMobile:false},
    {def: 'receivedTime',showMobile:false},
  ];
  dataCheckVneid: any;
  public userType: number = Number(localStorage.getItem('userType'));

  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      signOption: string,
      slotDocuments: any,
      filterSignAll: any
    },
    private router: Router,
    private documentService: DocumentService,
    private message: Message,
    private responsiveService: ResponsiveService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private contractService: ContractService,
    private dialogRef: MatDialogRef<SignDocumentListComponent>,
    private toastr: ToastrService,
    public deviceService: DeviceDetectorService,
    private documentMohaService: DocumentMohaService,
  ) {
    this.signOption = data.signOption;
    this.slotDocuments = data.slotDocuments;
    this.filterSignAll = data.filterSignAll;
  }

  /**
   * Initialize data.
   */
  ngOnInit() {

    // if (this.commonService.checkEnterpriseType()) {
    //   this.isVContract = false;
    // }
    //
    // if (this.isVContract) {
    //   this.columnDefinitions.splice(-2, 0, {def: 'bctConfirmStatus', showXS: false, showSM: false, showMD: true},);
    //   this.displayedColumns.splice(-2, 0, 'bctConfirmStatus');
    // }
    if (this.signOption === SignDocumentListComponent.SIGN_ALL) {
      this.loadDocumentsBySignAll();
    } else {
      console.log("slot: " + JSON.stringify(this.slotDocuments));
      this.dialogRef.addPanelClass('dialog-hidden');
      const dataSource = this.slotDocuments.value.map(item => ({
        ...item,
        contractName: item.name,
      }));

      const validData = dataSource.filter(x => x.status === 2 && x.cStatus !== 3 && x.cStatus !== 5);
      const notifyWarningStr = this.commonService.format(this.message.getMessage('messages.warning_multi_sign_lot'), dataSource.length - validData.length, dataSource.length, validData.length);
      this.notifyWarning = validData.length === dataSource.length ? '' : notifyWarningStr;
      this.dataSource = validData;
      this.noOfFiles = validData.reduce(function (s, a) {
        return s + a.contractAttachments.length;
      }, 0);
      this.completeData = true;
      this.dialogRef.removePanelClass('dialog-hidden');
    }
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    this.actions.next(SignDocumentListComponent.CLOSE_ACTION);
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
    this.actions.next(SignDocumentListComponent.CONFIRM_ACTION);
  }

  /**
   * Load document by sign all.
   */
  private loadDocumentsBySignAll() {
    this.dialogRef.addPanelClass('dialog-hidden');
    this.documentService.getDocumentsBySignAll(this.filterSignAll)
      .subscribe(rs => {
    if (rs && rs.data) {
          this.dataSource = rs.data;
    this.completeData = true;
    this.noOfFiles = this.dataSource.reduce(function (s, a) {
      return s + a.contractAttachments.length;
    }, 0);
    this.dialogRef.removePanelClass('dialog-hidden');
    }
         
    });
  }

  async actionConfirmSign() {
    let listApproverSignMoha = [];
    if (this.signOption === SignDocumentListComponent.SIGN_ALL) {
      listApproverSignMoha = this.dataSource.filter(doc => doc.isEmploymentContract);
    } else {
      listApproverSignMoha = this.dataSource.filter(doc => doc.status == 2 && doc.isEmploymentContract);
    }
    if (listApproverSignMoha.length > 0) {
      if (this.userType == 1 || this.userType == 2 || this.userType == 5) {
        this.checkAuthenVneid(() => this.actionSignAll());
        return
      }
      this.actionSignAll();
    }
    this.onClickConfirmButton();
  }


  actionSignAll() {
    this.checkTindy(() => {
      this.onClickConfirmButton();
    });
  }

  checkTindy(callback: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        callback();
      }
    })
  }

  checkAuthenVneid(callback?: () => void) {
    this.documentMohaService.getCheckVneidConfirm(null, true).subscribe(res => {
      if (res.success) {
        this.dataCheckVneid = res.data;
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO': 
            this.openRequestConfirmIdentity(callback);
            break;
          case 'FACE_MATCH': 
            this.openRequestConfirmIdentity(callback);
            break;
          case 'VERIFIED': 
            callback();
            break;
        }
      } else {
        this.toastr.error(res.message);
      }
    })
  }

  private openRequestConfirmIdentity(callback?: () => void): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(callback);
      }
    });
  }

  private openEnterIdentityVneid(callback?: () => void): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: null,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(callback);
        return;
      } else {
        callback();
      }
    });
  }

}
